import React from 'react';
import { Phone, Calendar } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ADVISOR_PHONE } from './SEOHead';
import { trackWhatsAppClick, trackPhoneClick } from '../services/analytics';

const MobileStickyBar = () => {
  const location = useLocation();
  const { i18n } = useTranslation();
  const isTe = i18n.language === 'te';

  // Don't show on contact page to prevent clutter
  if (location.pathname === '/contact') return null;

  const waMsg = isTe
    ? 'నమస్కారం V. S. రెడ్డి గారు, నాకు బీమా ప్లానింగ్ కోసం వ్యక్తిగత వివరాలు కావాలి.'
    : 'Hi V. S. Reddy, I would like to get a personalized quote for insurance planning.';

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-white/95 dark:bg-slate-900/95 backdrop-blur-lg border-t border-slate-200 dark:border-slate-800 p-2 sm:hidden shadow-2xl">
      <div className="grid grid-cols-3 gap-2">
        <a
          href={`tel:${ADVISOR_PHONE}`}
          onClick={() => trackPhoneClick('mobile_sticky_bar')}
          className="flex flex-col items-center justify-center py-2 px-1 bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 text-slate-800 dark:text-white rounded-xl text-[11px] font-bold transition-colors"
          aria-label={isTe ? 'సలహాదారునికి కాల్' : 'Call Advisor'}
        >
          <Phone className="w-4 h-4 text-primary mb-1" />
          <span>{isTe ? 'కాల్ చేయండి' : 'Call Advisor'}</span>
        </a>

        <a
          href={`https://wa.me/919849664800?text=${encodeURIComponent(waMsg)}`}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackWhatsAppClick('mobile_sticky_bar')}
          className="flex flex-col items-center justify-center py-2 px-1 bg-emerald-600 hover:bg-emerald-500 text-white rounded-xl text-[11px] font-bold shadow-md shadow-emerald-700/20 transition-colors"
          aria-label={isTe ? 'వాట్సాప్' : 'WhatsApp'}
        >
          <Phone className="w-4 h-4 text-white mb-1" />
          <span>{isTe ? 'వాట్సాప్' : 'WhatsApp'}</span>
        </a>

        <Link
          to="/contact"
          className="flex flex-col items-center justify-center py-2 px-1 bg-slate-900 dark:bg-white text-white dark:text-slate-900 rounded-xl text-[11px] font-bold transition-colors"
          aria-label={isTe ? 'సలహా పొందండి' : 'Book Advice'}
        >
          <Calendar className="w-4 h-4 mb-1" />
          <span>{isTe ? 'సలహా పొందండి' : 'Book Advice'}</span>
        </Link>
      </div>
    </div>
  );
};

export default MobileStickyBar;
